import { useEffect, useState } from "react";
import { deleteTradingAccount, getTradingAccounts } from "./TradingAccountService";

export default function TradingAccountList({ refreshKey }) {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    load();
  }, [refreshKey]);

  const load = async () => {
    const data = await getTradingAccounts();
    setAccounts(data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete trading account?")) return;
    await deleteTradingAccount(id);
    load();
  };

  return (
    <div className="card">
      <div className="data-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Broker</th>
              <th>Account</th>
              <th>Currency</th>
              <th>Active</th>
              <th>Comment</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((a) => (
              <tr key={a.id}>
                <td>{a.brokerName}</td>
                <td>{a.accountNumber}</td>
                <td>{a.baseCurrency}</td>
                <td>{a.isActive ? "Yes" : "No"}</td>
                <td>{a.comment}</td>
                <td>
                  <button className="btn btn-danger" onClick={() => handleDelete(a.id)}>
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
            {accounts.length === 0 && (
              <tr>
                <td colSpan="6">No trading accounts found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
